"use client";
import { ApiMsgTypes } from "@/api/AppApi/common-interfaces/IResultStamp";
import { useGetCartQuery, useManageCartItem } from "@/api/AppApi/services/cart";
import { IGetCart } from "@/api/AppApi/services/cart/interfaces/cart-interfaces";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import { useCallback, useEffect, useState } from "react";
import HBtnExpandingAddToCard from "./btn-esxpanding-types/HBtnExpandingAddToCard";
import VBtnExpandingAddToCard from "./btn-esxpanding-types/VBtnExpandingAddToCard";
import {
  countFromCart,
  debounce,
  getCartId,
  getById_ItemPropsToPost_Product_Event,
} from "@/app/components/pages-components/cart/cart-functions";
import ClearCartModal from "@/app/components/pages-components/cart/all-cart-items/ClearCartModal";
import FlyingImage, { IPoint } from "@/app/components/lib/FlyingImage";
import { goToCartAtom } from "@/app/components/pages-components/common/go-to-cart-pop-up/GoToCartPopUp";
import { useAtom } from "jotai";
import NotFieldErrModal from "@/app/components/common-form-builder/form-builder-helpers/NotFieldErrModal";
import { currencyAtom } from "@/hooks/currencyAtom";
import useEventTrackers from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/useEventTrackers";
import useProductPopup from "@/hooks/useProductPopup";
import { EventType } from "@/utils/helpers/pixel-helpers/hooks/useEventTrackers/helpers/interfaces";
import useSellingMode from "@/hooks/useSellingMode";
import { IEventCustomData } from "@/api/AppApi/services/home/IEvent";
import { ProductPreviewTypes } from "@/api/AppApi/services/product/interfaces/api-product-details-interface";
import { isKWCompliance } from "@/utils/functions/global-constants";
import { useProductBox } from "../../context/ProductBoxContext";
import ProductAttrbuitesPopUp from "@/app/components/common-builder/pop-ups-components/Product-Details-pop-up/ProductAttrbuitesPopUp";
import { IProduct } from "@/api/AppApi/services/home/interfaces/IProduct";

interface Props {
  vertical?: boolean;
  HBFullWidth: boolean;
  productSlug: string;
  isConfigurableProduct: boolean;
  preview_type: string;
  custom_data?: IEventCustomData;
  productProps?: IProduct;
}
const BtnExpandingAddToCard: React.FC<Props> = ({
  vertical = false,
  HBFullWidth,
  productSlug,
  isConfigurableProduct,
  preview_type,
  custom_data,
  productProps,
}) => {
  const {
    selectedChild,
    attrs_values,
    quantity,
    setQuantity,
    addedToCart,
    selectedAttributes,
    showselectAttrsPopup,
    product,
    setSelectedChildIndex,
    selectedChildIndex,
    currentProductInCart,
    outOfStock,
    viewDetails,
    mustViewDetails,
  } = useProductBox();
  const {
    id,
    quantity_on_hand,
    min_quantity_in_cart,
    max_quantity_in_cart,
    image_url,
  } = selectedChild ?? {};
  const productId = id;

  const getComapny = useGetCompanyQuery();
  const router = useRouter();
  const [currency] = useAtom(currencyAtom);
  const { eventTrackers } = useEventTrackers();
  const { enableSells } = useSellingMode();
  const addToCartTxt =
    getComapny?.data?.result?.theme?.components?.product?.add_to_cart_btn_title;

  const maxQuantity = max_quantity_in_cart
    ? Math.min(quantity_on_hand, max_quantity_in_cart)
    : quantity_on_hand;

  const [notFieldErr, setNotFieldErr] = useState<string[]>([]);
  const [xy, setXy] = useState<IPoint | null>(null);
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [, setOpenGoToCartPopUp] = useAtom(goToCartAtom);
  const getCart = useGetCartQuery();
  const cartItems = getCart?.data?.result?.items;

  const cartItemId = currentProductInCart?.id;
  const { handleOpenPopup } = useProductPopup();

  const handleQuantity = (quantity: number) => {
    setQuantity(quantity);
  };

  const KWC = isKWCompliance(getComapny.data?.result!);

  const manageCartApi = useManageCartItem({
    onSuccess: (res: IGetCart) => {
      const { items, coupon } = res.result ?? {};
      if (res?.message?.type === ApiMsgTypes.success) {
        const addedItem = items.find((item) => item.inner_id === productId)!;
        eventTrackers(EventType.ADD_CART, [addedItem], {
          currency: currency?.code,
          value: addedItem.price,
          coupon: coupon?.code ?? "",
          discount: addedItem.discount,
        });
        if (KWC) {
          router.push("/checkout");
          return;
        }
      }
    },
    onError: (error) => {
      // console.log(error);
      const currenQuantity = currentProductInCart?.quantity ?? 0;
      handleQuantity(currenQuantity);
      setNotFieldErr([error?.response?.data?.message?.text]);
    },
  });

  useEffect(() => {
    if (getCart.isLoading) return;
    handleQuantity(
      countFromCart(cartItems!, productId, isConfigurableProduct, cartItemId),
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cartItems, getCart.isLoading]);

  const mutateQty = (qty: number) => {
    const cartItem = getById_ItemPropsToPost_Product_Event(
      cartItems!,
      productId,
      preview_type as ProductPreviewTypes,
      cartItemId,
    );

    manageCartApi.mutate({
      ...cartItem,
      quantity: qty,
      attrs_values: cartItem?.cartId ? cartItem?.attrs_values : attrs_values,
    });
  };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debounceMutate = useCallback(debounce(mutateQty, 500), [
    cartItems?.length,
    cartItemId,
    productId,
  ]);

  const handleQuantityChange = (qty: number) => {
    if (qty === 0) {
      setShow(true);
    } else {
      handleQuantity(qty);
      debounceMutate(qty);
    }
  };
  const handleIncreaseQty = (e: React.MouseEvent, value: number = 1) => {
    setXy({ x: e.clientX, y: e.clientY });
    handleQuantityChange(quantity + value);
    if (quantity === 0) {
      setOpenGoToCartPopUp(true);
    }
  };
  const handleChangeQty = (value: number) => {
    handleQuantityChange(value);
    if (quantity === 0) {
      setOpenGoToCartPopUp(true);
    }
  };
  const handleDecreaseQty = (value: number = 1) => {
    handleQuantityChange(quantity - value);
  };

  const handleRemoveFormCart = () => {
    setShow(false);
    handleQuantity(0);
  };
  const viewdetailsClick = () => {
    showselectAttrsPopup && !mustViewDetails
      ? setIsOpen(true)
      : isConfigurableProduct
      ? handleOpenPopup({
          productID: productSlug,
          AttrbuitesInitialValues: selectedAttributes,
        })
      : router.push(`/products/${productSlug}`);
  };
  const AddToCartBtn = vertical
    ? VBtnExpandingAddToCard
    : HBtnExpandingAddToCard;
  return (
    <>
      {notFieldErr.length > 0 && (
        <NotFieldErrModal errors={notFieldErr} setErrors={setNotFieldErr} />
      )}
      <ClearCartModal
        show={show}
        id={getCartId(cartItems!, productId, cartItemId)!}
        setShow={setShow}
        onOk={handleRemoveFormCart}
      />
      {xy && (
        <FlyingImage src={image_url} startCoord={xy} setStartCoord={setXy} />
      )}
      <AddToCartBtn
        HBFullWidth={HBFullWidth}
        preview_type={preview_type}
        quantity={quantity}
        increaseQty={handleIncreaseQty}
        decreaseQty={handleDecreaseQty}
        viewDetails={viewDetails}
        outOfStock={outOfStock}
        maxQuantity={maxQuantity}
        minQuantity={min_quantity_in_cart ?? 1}
        enable_sells={enableSells ?? true}
        viewDetailsClick={viewdetailsClick}
        isConfigurableProduct={!!isConfigurableProduct}
        addToCartTxt={addToCartTxt}
        handleChangeQty={handleChangeQty}
        custom_data={custom_data}
        addedToCart={addedToCart}
        isLoading={manageCartApi.isLoading}
        shouldReminder={
          getComapny.data?.result.theme?.components.product
            .allow_user_request_stock_availability_reminder
        }
        productProps={productProps}
      />
      <ProductAttrbuitesPopUp
        HBFullWidth
        preview_type={preview_type}
        quantity={quantity}
        increaseQty={handleIncreaseQty}
        decreaseQty={handleDecreaseQty}
        viewDetails={viewDetails}
        outOfStock={outOfStock}
        maxQuantity={maxQuantity}
        minQuantity={min_quantity_in_cart ?? 1}
        enable_sells={enableSells ?? true}
        viewDetailsClick={viewdetailsClick}
        isConfigurableProduct={!!isConfigurableProduct}
        addToCartTxt={addToCartTxt}
        handleChangeQty={handleChangeQty}
        addedToCart={addedToCart}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        product={product}
        setSelectedChildIndex={setSelectedChildIndex}
        attrsInitValues={selectedAttributes}
        isAddingToCart={manageCartApi.isLoading}
        choose_variant={product.is_configurable && !selectedChildIndex}
        shouldReminder={
          getComapny.data?.result.theme?.components.product
            .allow_user_request_stock_availability_reminder
        }
        productProps={productProps}
      />
    </>
  );
};

export default BtnExpandingAddToCard;
